module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli.7f796453.pdf";